import { lazy } from 'react';

const ReceivedTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/received-transfer',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedTransformerTransferConfig;


